module.exports = __webpack_public_path__ + "img/success.71c1ef54.svg";